import type { StytchB2BHeadlessClient } from '@stytch/vanilla-js/b2b/headless'
import { SESSION_DURATION_MINUTES } from './constants'

export class SessionHeartbeat {
  private static instance: SessionHeartbeat | null = null
  private heartbeatInterval: NodeJS.Timeout | null = null
  private readonly HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000 // 5 minutes
  private stytchClient: StytchB2BHeadlessClient

  private constructor(stytchClient: StytchB2BHeadlessClient) {
    this.stytchClient = stytchClient
  }

  static getInstance(stytchClient: StytchB2BHeadlessClient): SessionHeartbeat {
    if (!SessionHeartbeat.instance) {
      SessionHeartbeat.instance = new SessionHeartbeat(stytchClient)
    }
    return SessionHeartbeat.instance
  }

  private async sendHeartbeat(): Promise<void> {
    try {
      // Use Stytch's session.authenticate() to extend the session
      await this.stytchClient.session.authenticate({
        session_duration_minutes: SESSION_DURATION_MINUTES
      })
    } catch (error) {
      console.error('Failed to send session heartbeat', error)
      // Don't stop the heartbeat on error, let it retry on next interval
    }
  }

  private startHeartbeat(): void {
    // Clear any existing interval
    this.stopHeartbeat()

    // Send initial heartbeat
    void this.sendHeartbeat()

    // Set up recurring heartbeat
    this.heartbeatInterval = setInterval(() => {
      void this.sendHeartbeat()
    }, this.HEARTBEAT_INTERVAL_MS)
  }

  private stopHeartbeat(): void {
    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval)
      this.heartbeatInterval = null
    }
  }

  public start(): void {
    this.startHeartbeat()
  }

  public stop(): void {
    this.stopHeartbeat()

    // Clear the singleton instance
    SessionHeartbeat.instance = null
  }
}
